import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { ObserveProperty } from "@calaosoft/osapp-common/observable/decorators/observe-property.decorator";
import { ObservableProperty } from "@calaosoft/osapp-common/observable/models/observable-property";
import { secure } from "@calaosoft/osapp-common/rxjs/operators/secure";
import { NumberHelper } from "@calaosoft/osapp-common/utils/helpers/numberHelper";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DestroyableComponentBase } from "../../../../utils/components/destroyable-component-base";
import { ICountingCategoryItem } from "../categories/models/icounting-category-item";
import { ILotEditComponentParam } from "../models/ILotEditComponentParam";

@Component({
	selector: "calao-lot-edit",
	templateUrl: "./lot-edit.component.html",
	styleUrls: ["./lot-edit.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class LotEditComponent extends DestroyableComponentBase implements ILotEditComponentParam {
	//#region FIELDS

	/** Fonction appelée si l'utilisateur veut ajouter la valeur au lot courant. */
	@Output("addToLot") private readonly moAddToLotEvent = new EventEmitter<number>();
	/** Fonction appelée si l'utilisateur veut ajouter la valeur à un nouveau lot. */
	@Output("addNewLot") private readonly moAddNewLotEvent = new EventEmitter<number>();

	//#endregion FIELDS

	//#region PROPERTIES

	/** @implements */
	@Input() public category: ICountingCategoryItem;
	@ObserveProperty<LotEditComponent>({ sourcePropertyKey: "category" })
	public readonly observableCategory = new ObservableProperty<ICountingCategoryItem>();

	/** @implements */
	@Input() public lastLot: number;
	@ObserveProperty<LotEditComponent>({ sourcePropertyKey: "lastLot" })
	public readonly observableLastLot = new ObservableProperty<number>();

	/** @implements */
	@Input() public canAddNewLot: boolean;
	@ObserveProperty<LotEditComponent>({ sourcePropertyKey: "canAddNewLot" })
	public readonly observableCanAddNewLot = new ObservableProperty<boolean>();

	/** @implements */
	@Input() public totalCategoryItems: number;
	@ObserveProperty<LotEditComponent>({ sourcePropertyKey: "totalCategoryItems" })
	public readonly observableTotalCategoryItems = new ObservableProperty<number>();

	public readonly observableValue = new ObservableProperty<number>();

	/** Vérifie si on peut ajouter un nouveau lot ou lot existant. */
	public readonly isValid$: Observable<boolean> = this.getIsValid$().pipe(secure(this));

	//#endregion

	//#region METHODS

	constructor() {
		super();
	}

	private getIsValid$(): Observable<boolean> {
		return this.observableValue.value$.pipe(map((pnValue: number) => NumberHelper.isValidPositive(pnValue)));
	}

	public onAddToLot(): void {
		if (NumberHelper.isValidPositive(this.observableValue.value)) this.moAddToLotEvent.emit(this.observableValue.value);
	}

	public onAddToNewLot(): void {
		this.moAddNewLotEvent.emit(this.observableValue.value);
	}

	public valueChanged(pnValue: number): void {
		this.observableValue.value = pnValue;
	}

	//#endregion
}
